'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('../../../tslib.es6-fe93d37b.js');
require('../../../constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
require('styled-components');
require('../../../svg-icon-501cae97.js');
require('../../../arrow-left-chevron-4cbe9905.js');
require('../../../close-40bc5458.js');
require('../../../enums-de2d9d36.js');
require('../../../_commonjsHelpers-1b94f6bc.js');
require('../../../index-d4dda1ce.js');
require('../../../index-6aab2a08.js');
require('../../../index.es-1f72f6f2.js');
require('react-dom');
require('../../../component-0d3539a5.js');
var swipeModalContent = require('../../../swipeModalContent-1effaf4d.js');

var userActionStartValues = {
    position: 0,
    startCursorPosition: 0,
};
var useSlideActions = function (position, setPosition, onSelect) {
    var _a = tslib_es6.__read(React.useState(false), 2), isSlide = _a[0], setIsSlide = _a[1];
    var handleStart = React.useCallback(function (cursorPosition) {
        userActionStartValues.position = position;
        userActionStartValues.startCursorPosition = cursorPosition;
    }, [position]);
    var handleMove = React.useCallback(function (cursorPosition) {
        var offset = cursorPosition - userActionStartValues.startCursorPosition;
        setPosition(offset, userActionStartValues.position);
    }, [setPosition]);
    var handleEnd = React.useCallback(function () {
        onSelect();
    }, [onSelect]);
    var handleMouseUp = React.useCallback(function () {
        if (!isSlide)
            return;
        setIsSlide(false);
        handleEnd();
    }, [setIsSlide, isSlide, handleEnd]);
    var handleMouseDown = React.useCallback(function (event) {
        setIsSlide(true);
        handleStart(event.pageY || event.clientY);
    }, [setIsSlide, handleStart]);
    var handleTouchStart = React.useCallback(function (event) {
        handleStart(event.targetTouches[0].pageY);
    }, [handleStart]);
    var handleMouseMove = React.useCallback(function (event) {
        if (!isSlide)
            return;
        handleMove(event.pageY || event.clientY);
    }, [handleMove, isSlide]);
    var handleTouchMove = React.useCallback(function (event) {
        event.stopPropagation();
        handleMove(event.targetTouches[0].pageY);
    }, [handleMove]);
    return {
        handleMouseDown: handleMouseDown, handleMouseMove: handleMouseMove, handleMouseUp: handleMouseUp, handleTouchStart: handleTouchStart, handleTouchMove: handleTouchMove, handleEnd: handleEnd, isSlide: isSlide,
    };
};

var MIN_POSITION_VALUE = 28;
var useSwipeModalActions = function (onClose, initialPosition) {
    var screenHeight = React.useMemo(function () { return document.documentElement.clientHeight; }, []);
    var _a = tslib_es6.__read(React.useState(initialPosition ? screenHeight - initialPosition : screenHeight), 2), position = _a[0], setPosition = _a[1];
    var _b = tslib_es6.__read(React.useState(true), 2), isAnimated = _b[0], setIsAnimated = _b[1];
    var handleSetPosition = React.useCallback(function (pos, start) {
        var newPosition = start + pos;
        var maxPosition = screenHeight - swipeModalContent.contentOffsetTop;
        if (newPosition < MIN_POSITION_VALUE || newPosition > maxPosition) {
            return;
        }
        setPosition(newPosition);
    }, [screenHeight]);
    var handleOnClose = React.useCallback(function (callback) {
        setIsAnimated(true);
        setPosition(screenHeight - (initialPosition !== null && initialPosition !== void 0 ? initialPosition : 0));
        setTimeout(function () {
            setIsAnimated(false);
            if (typeof callback === 'function') {
                callback();
            }
            else if (typeof onClose === 'function') {
                onClose();
            }
        }, 300);
    }, [initialPosition, screenHeight, onClose]);
    var handleSlideUp = React.useCallback(function (timeout) {
        setIsAnimated(true);
        setPosition(MIN_POSITION_VALUE);
        setTimeout(function () {
            setIsAnimated(false);
        }, timeout);
    }, [setPosition, setIsAnimated]);
    var onSelect = React.useCallback(function () {
        if (position < Math.round(screenHeight / 2)) {
            handleSlideUp(300);
        }
        else {
            handleOnClose();
        }
    }, [position, screenHeight, handleOnClose, handleSlideUp]);
    React.useEffect(function () {
        if (initialPosition) {
            setPosition(screenHeight - initialPosition);
        }
        else {
            handleSlideUp(350);
        }
    }, [handleSlideUp, initialPosition, screenHeight]);
    return {
        position: position,
        isAnimated: isAnimated,
        handleSetPosition: handleSetPosition,
        handleOnClose: handleOnClose,
        onSelect: onSelect,
        handleSlideUp: handleSlideUp,
    };
};
var useSwipeModal = function (onClose, initialPosition) {
    var _a = useSwipeModalActions(onClose, initialPosition), position = _a.position, isAnimated = _a.isAnimated, handleSetPosition = _a.handleSetPosition, handleOnClose = _a.handleOnClose, onSelect = _a.onSelect;
    var _b = useSlideActions(position, handleSetPosition, onSelect), handleMouseDown = _b.handleMouseDown, handleMouseMove = _b.handleMouseMove, handleMouseUp = _b.handleMouseUp, handleTouchStart = _b.handleTouchStart, handleTouchMove = _b.handleTouchMove, handleEnd = _b.handleEnd, isSlide = _b.isSlide;
    React.useEffect(function () {
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        return function () {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [handleMouseMove, handleMouseUp, isSlide]);
    return {
        position: position,
        isAnimated: isAnimated,
        isSlide: isSlide,
        handleOnClose: handleOnClose,
        handleMouseDown: handleMouseDown,
        handleTouchStart: handleTouchStart,
        handleTouchMove: handleTouchMove,
        handleEnd: handleEnd,
    };
};

var SwipeModalComponent = function (props, ref) {
    var content = props.content, title = props.title, subtitle = props.subtitle, footerContent = props.footerContent, onClose = props.onClose, onPressBack = props.onPressBack, className = props.className, _a = props.withLeftExitButton, withLeftExitButton = _a === void 0 ? true : _a, _b = props.withBackButton, withBackButton = _b === void 0 ? false : _b, backgroundColor = props.backgroundColor, contentStyles = props.contentStyles, reverseAnimation = props.reverseAnimation, reverseHorizontalAnimation = props.reverseHorizontalAnimation, _c = props.withLeftArrowButton, withLeftArrowButton = _c === void 0 ? false : _c, _d = props.isScrollableContent, isScrollableContent = _d === void 0 ? true : _d, _e = props.isModalWithoutSlideAnimation, isModalWithoutSlideAnimation = _e === void 0 ? true : _e, scrollContainerRef = props.scrollContainerRef, contentBodyRef = props.contentBodyRef, leftIcon = props.leftIcon, rightIcon = props.rightIcon, noContentPadding = props.noContentPadding, _f = props.noContentWrapperPadding, noContentWrapperPadding = _f === void 0 ? false : _f, _g = props.hasBackground, hasBackground = _g === void 0 ? true : _g, _h = props.isContentSlidable, isContentSlidable = _h === void 0 ? false : _h, initialPosition = props.initialPosition;
    var _j = useSwipeModal(onClose, initialPosition), position = _j.position, isAnimated = _j.isAnimated, isSlide = _j.isSlide, handleOnClose = _j.handleOnClose, handleMouseDown = _j.handleMouseDown, handleTouchStart = _j.handleTouchStart, handleTouchMove = _j.handleTouchMove, handleEnd = _j.handleEnd;
    React.useImperativeHandle(ref, function () { return ({
        closeModal: function (callback) {
            handleOnClose(callback);
        },
    }); });
    var onCloseCb = React.useCallback(function () { return handleOnClose(); }, [handleOnClose]);
    var defaultCustomLeftIcon;
    if (!withLeftArrowButton && !withBackButton) {
        defaultCustomLeftIcon = (React__default.createElement(swipeModalContent.LeftLargeCloseIcon, { onClick: onCloseCb, className: "left-large-close-icon", "data-testid": "modal-wrapper-large-exit-button" }));
    }
    if (withLeftArrowButton && !withBackButton) {
        defaultCustomLeftIcon = (React__default.createElement(swipeModalContent.LeftLargeArrowIcon, { onClick: onPressBack, className: "left-large-arrow-icon", "data-testid": "modal-wrapper-left-large-arrow-button" }));
    }
    return (React__default.createElement(swipeModalContent.StyledMobileWrapper, tslib_es6.__assign({ visible: true, reverseAnimation: reverseAnimation, content: (React__default.createElement(swipeModalContent.SwipeModalContent, tslib_es6.__assign({ noContentWrapperPadding: noContentWrapperPadding, isModalWithoutSlideAnimation: isModalWithoutSlideAnimation, reverseHorizontalAnimation: reverseHorizontalAnimation, content: content, title: title, subtitle: subtitle, footerContent: footerContent, isScrollableContent: isScrollableContent, scrollContainerRef: scrollContainerRef, contentBodyRef: contentBodyRef, noContentPadding: noContentPadding }, (!isContentSlidable && {
            handleMouseDown: handleMouseDown,
            handleTouchStart: handleTouchStart,
            handleTouchMove: handleTouchMove,
            handleEnd: handleEnd,
        })))), onClose: handleOnClose, onPressBack: onPressBack, className: className, withLeftExitButton: withLeftExitButton, withLeftArrowButton: withLeftArrowButton, withBackButton: withBackButton, backgroundColor: backgroundColor, contentStyles: contentStyles, position: position, isAnimated: isAnimated, isSlide: isSlide, leftIcon: leftIcon !== null && leftIcon !== void 0 ? leftIcon : defaultCustomLeftIcon, rightIcon: rightIcon, hasBackground: hasBackground }, (isContentSlidable && {
        handleMouseDown: handleMouseDown,
        handleTouchStart: handleTouchStart,
        handleTouchMove: handleTouchMove,
        handleEnd: handleEnd,
    }))));
};
var SwipeModal = React.forwardRef(SwipeModalComponent);
SwipeModal.displayName = 'SwipeModal';

exports.SwipeModal = SwipeModal;
